import React from "react";
import { stats } from "../data/content";
export function Stats() {
  return <section aria-label="Resultados" className="border-y border-ink-3 bg-ink-2 px-6 py-12 sm:py-14" data-id="element-116" data-mp="2wxgkidhn9r7g">
      <dl className="mx-auto grid max-w-5xl grid-cols-2 gap-y-10 md:grid-cols-4 md:divide-x md:divide-ink-4" data-id="element-117" data-mp="2iy7fm9yw2jis">
        {stats.map(s => <div key={s.label} className="px-3 text-center" data-id="element-118" data-mp="2nvqsp6juoq95">
            <dt className="sr-only" data-id="element-119" data-mp="298e4tb6km8fl">{s.label}</dt>
            <dd className="font-serif text-[clamp(34px,5vw,52px)] font-black leading-none text-gold" data-id="element-120" data-mp="296kzq0blvw9p">{s.value}</dd>
            <dd className="mx-auto mt-3 max-w-[180px] text-[13px] leading-snug text-muted" data-id="element-121" data-mp="2e0yvi3u6k5ew">{s.label}</dd>
          </div>)}
      </dl>
    </section>;
}